export function removeUrlHash(url: string) {
  const hashIndex = url.indexOf('#');
  return hashIndex >= 0 ? url.slice(0, hashIndex) : url;
}

export function toAbsoluteWechatUrl(url: string | undefined, baseUrl: string) {
  if (!url) return undefined;
  try {
    return new URL(url, baseUrl).toString();
  } catch {
    return undefined;
  }
}

export function selectWechatSignatureUrl(input: {
  initialUrl: string;
  currentUrl: string;
  userAgent: string;
}) {
  const currentUrl = removeUrlHash(input.currentUrl);
  const initialUrl = removeUrlHash(input.initialUrl || input.currentUrl);
  const isIosWechat =
    /MicroMessenger/i.test(input.userAgent) &&
    /iPhone|iPad|iPod/i.test(input.userAgent);

  // iOS WeChat validates SPA pages against the first document URL.
  // Android WeChat validates against the current address.
  return isIosWechat ? initialUrl : currentUrl;
}
